export default "__VITE_PUBLIC_ASSET__f211c730__"